import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnInit,
    ViewEncapsulation,
    ChangeDetectorRef,
    OnChanges
} from '@angular/core';

@Component({
    selector: 'a[fcp-link]',
    host: {
        '[class.fcp-text-link-s]': "size === 'small'",
        '[class.fcp-text-link-m]': "size === 'medium'",
        '[class.fcp-text-link-l]': "size === 'large'",
        '[class.fcp-link-prominent]': "color === 'default' || color === 'prominent'",
        '[class.fcp-link-subtle]': "color === 'subtle'",
        '[class.fcp-link-critical]': "color === 'critical'",
        '[class.fcp-link-warning]': "color === 'warning'",
        '[class.fcp-link-success]': "color === 'success'",
        '[class.fcp-link-info]': "color === 'info'",
        class: 'fcp-link'
    },
    templateUrl: './fcp-link.component.html',
    styleUrls: ['./fcp-link.component.less'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FcpLinkComponent implements OnInit, OnChanges {
    @Input() size: FcpLinkSizes = FcpLinkSizes.Medium;
    @Input() color: FcpLinkColors = FcpLinkColors.Default;

    constructor(private cdr: ChangeDetectorRef) {}

    ngOnInit(): void {
        this.cdr.markForCheck();
    }

    ngOnChanges(): void {
        this.cdr.markForCheck();
    }
}

export enum FcpLinkColors {
    Default = 'default',
    Prominent = 'prominent',
    Subtle = 'subtle',
    Success = 'success',
    Critical = 'critical',
    Warning = 'warning',
    Info = 'info'
}

export enum FcpLinkSizes {
    Small = 'small',
    Medium = 'medium',
    Large = 'large'
}
